import { WrenchTheme } from '@wds/styles';
import merge from 'lodash.merge';

const theme = {};

export default merge({}, theme, WrenchTheme);
